import { commonTemplates, productCardTemplate, searchWidgetTemplates, searchSuggestionsTemplate, searchSuggestionsFallbackTemplate, collectionWidgetTemplates, shopifyFallbackWidgets } from './commonTemplates';
import { onSuccessfulAPICall } from './onSuccessfulAPICall';
import { collectionPanelsTemplate } from './collectionPanelsTemplate';

let defaultTagalysLocale = window.tagalysConfig.locale;
let defaultTagalysCurrencyCode = window.tagalysConfig.currencyCode;
let defaultTagalysCurrencyLabel = window.tagalysConfig.currencyLabel;
let defaultTagalysCountry = window.tagalysConfig.country;
let defaultTagalysBaseCountry = window.tagalysConfig.baseCountry;
let defaultTagalysLanguage = window.tagalysConfig.language;

if (window?.Shopify?.currency.active) {
  defaultTagalysCurrencyCode = window.Shopify.currency.active;
}

if (window?.Shopify?.country) {
  defaultTagalysCountry = window.Shopify.country;
  defaultTagalysLanguage = window.Shopify.locale;
  defaultTagalysLocale = `${defaultTagalysLanguage}-${defaultTagalysCountry.toUpperCase()}`
}

/* get currency label */
let formatter = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: defaultTagalysCurrencyCode,
  currencyDisplay: "narrowSymbol",
  minimumFractionDigits: 0
});

// Format a dummy number just to extract the symbol
let parts = formatter.formatToParts(1);

defaultTagalysCurrencyLabel = parts.find(p => p.type === "currency").value;
window.defaultTagalysCurrencyLabel = defaultTagalysCurrencyLabel;
/* END get currency label */

window.TagalysCustomisations = {};

window.TagalysCustomisations.setTagalysConfiguration = function () {
  const configuration = {
    api: {
      serverUrl: window.tagalysConfig.serverUrl,
      apiKey: window.tagalysConfig.apiKey
    },
    locale: defaultTagalysLocale,
    numberFormatter: function (number, fractionalDigits) {
      if (fractionalDigits !== undefined) {
        return new Intl.NumberFormat(defaultTagalysLocale, {
          style: "currency",
          currency: defaultTagalysCurrencyCode,
          currencyDisplay: "narrowSymbol"
        }).format(number);
      }
      return number;
    },
    currency: {
      displayFormatter: '{{value}}',
      code: defaultTagalysCurrencyCode,
      label: defaultTagalysCurrencyLabel,
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided() {
      return true;
    },
    track: true
  };
  Tagalys.setConfiguration(configuration);
};

window.TagalysCustomisations.setPlatformConfiguration = function () {
  const platformConfiguration = {
    platform: 'Shopify',
    countryCode: defaultTagalysCountry,
    baseCountryCode: defaultTagalysBaseCountry,
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: window.storefrontAccessToken.tagalys,
      myShopifyDomain: window.Shopify.shop
    },
    metafields: {
      products: [
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--personalisation`,
          key: 'reference'
        },
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--personalisation`,
          key: 'hasOnlyUpsells'
        },
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--pdp`,
          key: 'colour'
        },
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--pdp`,
          key: 'color_variants'
        },
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--pdp`,
          key: 'stickers'
        },
        {
          namespace: `app--${window.tagalysConfig.environmentAppid}--pdp`,
          key: 'material'
        }
      ]
    }
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

window.TagalysCustomisations.initSearchSuggestions = function () {

  function initializeShopifySearchSuggestions() {
    return Tagalys.UIWidgets.ShopifySearchSuggestions.init('[data-search-input]', {
      searchResultsURL: '/search',
      templates: {
        ...searchSuggestionsFallbackTemplate,
        ...productCardTemplate,
      }
    });
  }

  Tagalys.UIWidgets.SearchSuggestions.init(['[data-search-input]'], {
    searchResultsURL: '/search',
    templates: {
      ...searchSuggestionsTemplate,
      ...productCardTemplate
    },
    failover: initializeShopifySearchSuggestions
  });
};

window.TagalysCustomisations.initSearchResults = function () {

  function initializeShopifySearch() {
    return Tagalys.UIWidgets.ShopifySearchResults.init('[data-search-results]', {
      callbacks: {
        onSuccessfulAPICall
      },
      templates: {
        ...commonTemplates,
        ...searchWidgetTemplates,
        ...productCardTemplate,
        ...shopifyFallbackWidgets
      }
    });
  }

  Tagalys.UIWidgets.SearchResults.init('[data-search-results]', {
    callbacks: {
      onSuccessfulAPICall
    },
    templates: {
      ...commonTemplates,
      ...searchWidgetTemplates,
      ...productCardTemplate,
      ...collectionPanelsTemplate
    },
    failover: initializeShopifySearch
  });
};

window.TagalysCustomisations.initCollection = function () {

  function initializeShopifyCollection() {
    return Tagalys.UIWidgets.ShopifyCollection.init('[data-product-listing-page]', {
      callbacks: {
        onSuccessfulAPICall
      },
      params: {
        collectionId: window.tagalysConfig.collectionId
      },
      templates: {
        ...commonTemplates,
        ...collectionWidgetTemplates,
        ...productCardTemplate,
        ...collectionPanelsTemplate,
        ...shopifyFallbackWidgets,
      }
    });
  }

  Tagalys.UIWidgets.Collection.init('[data-product-listing-page]', {
    callbacks: {
      onSuccessfulAPICall
    },
    params: {
      collectionId: window.tagalysConfig.collectionId
    },
    templates: {
      ...commonTemplates,
      ...collectionWidgetTemplates,
      ...productCardTemplate,
      ...collectionPanelsTemplate,
      paginationLinks: {
        options: {
          showPreviousPageLink: false,
          showFirstPageLink: false,
          showNextPageLink: false
        }
      }
    },
    failover: initializeShopifyCollection
  });
};

function onTagalysReady() {
  if (window.Tagalys) {
    window.TagalysCustomisations.setTagalysConfiguration();
    window.TagalysCustomisations.setPlatformConfiguration();
  }

  window.addEventListener('DOMContentLoaded', function () {
    if (window.Tagalys) {
      window.TagalysCustomisations.setTagalysConfiguration();
      window.TagalysCustomisations.setPlatformConfiguration();
    }
    checkDOMForTagalysWidgets();
  });
}

function checkDOMForTagalysWidgets() {
  // Initialize search results if the search results container is found
  const searchResults = document.querySelector('[data-search-results]');
  if (searchResults) {
    window.TagalysCustomisations.initSearchResults();
  }

  // Initialize search suggestions if the search input is found
  const searchInput = document.querySelector('[data-search-input]');
  if (searchInput) {
    window.TagalysCustomisations.initSearchSuggestions();
  }

  // Initialise the collections widget
  const collectionWidget = document.querySelector('[data-product-listing-page]');
  if (collectionWidget) {
    window.TagalysCustomisations.initCollection();
  }
}

onTagalysReady();
